import React, { useState } from 'react';
import { Button, TextField, Typography, Box, Snackbar, Paper } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import BASE_URL from '../config/apiConfig';

const NewsletterSubscription = () => {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubscribe = async (e) => {
        e.preventDefault();
      
        // Simple email validation to allow any valid email format
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          setError('Please enter a valid email address.');
          return;
        }

        try {
          // Make a request to the backend API to subscribe
          const response = await fetch(`${BASE_URL}/api/subscribe`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
          });

          if (response.ok) {
            setSuccess(true);
            setEmail('');
            setError('');
          } else {
            const errorData = await response.json();
            setError(errorData.message || 'Subscription failed. Please try again.');
          }
        } catch (error) {
          console.error('Error during subscription:', error);
          setError('An error occurred. Please try again.');
        }
    };

    const handleCloseSnackbar = () => {
        setSuccess(false);
    };

    return (
      <Paper
        elevation={3}
        sx={{
          padding: 3,
          borderRadius: 2,
          marginTop: 4,
          textAlign: "center",
          backgroundColor: "#ffffff",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#333" }}
        >
          Subscribe to Our Newsletter
        </Typography>
        <Typography variant="body2" gutterBottom sx={{ color: "#555" }}>
          Stay updated with the latest news and offers from our agritech
          solutions!
        </Typography>
        <form onSubmit={handleSubscribe}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              mb: 2,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <TextField
              type="email"
              label="Enter your email"
              variant="outlined"
              size="small"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                bgcolor: "#f9f9f9",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#51843a",
                  },
                  "&:hover fieldset": {
                    borderColor: "#2cabcb",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#51833a",
                  },
                },
                mr: { xs: 0, sm: 1 },
                mb: { xs: 1, sm: 0 },
                flexGrow: 1,
                maxWidth: { xs: "100%", sm: "300px" },
              }}
              required
            />
            <Button
              variant="contained"
              type="submit"
              sx={{
                backgroundColor: "#51843a",
                color: "#fff",
                "&:hover": { backgroundColor: "#2cabcb" },
                borderRadius: "8px",
                paddingY: "8px",
                fontWeight: "bold",
                transition: "background-color 0.3s ease",
                minWidth: "120px",
              }}
            >
              Subscribe
            </Button>
          </Box>
        </form>
        <Snackbar
          open={success}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message="Successfully subscribed!"
          action={<CheckCircle color="success" />}
        />
        {error && (
          <Typography variant="body2" color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Paper>
    );
};

export default NewsletterSubscription;
